export class ClinicSublocationModel {
    Sub_Location_ID: number;
    sub_location: string;
    sub_location_desc: string;
    clinic_dept_code: string;
    clinic_dept: string;
    specie: number;
    category: string;
    occupied: number;
    type: string;
    size: string;
    note: string;
    clinic_no: number

    constructor(
        Sub_Location_ID: number,
        sub_location: string,
        sub_location_desc: string,
        clinic_dept_code: string,
        clinic_dept: string,
        specie: number,
        category: string,
        occupied: number,
        type: string,
        size: string,
        note: string,
        clinic_no: number
    ) {
        this.Sub_Location_ID = Sub_Location_ID;
        this.sub_location = sub_location;
        this.sub_location_desc = sub_location_desc;
        this.clinic_dept_code = clinic_dept_code;
        this.clinic_dept = clinic_dept;
        this.specie = specie;
        this.category = category;
        this.occupied = occupied;
        this.type = type;
        this.size = size;
        this.note = note;
        this.clinic_no = clinic_no;
    }
}
